import React from 'react';
import styled from 'styled-components';
import { Check, ChevronRight, Delete, DeleteOutlined, ExpandMore, Folder, InsertDriveFile, InsertDriveFileOutlined } from '@material-ui/icons';
import { TreeItem } from '@material-ui/lab';
import { filterFileTree } from './FileExplorer';
const expandTrashIcon = (React.createElement(React.Fragment, null,
    React.createElement(ChevronRight, null),
    React.createElement(Delete, null)));
const collapseTrashIcon = (React.createElement(React.Fragment, null,
    React.createElement(ExpandMore, null),
    React.createElement(DeleteOutlined, null)));
const fileIcon = React.createElement(InsertDriveFile, { style: { marginLeft: 18 } });
const selectedFileIcon = (React.createElement(React.Fragment, null,
    React.createElement(Check, null),
    React.createElement(InsertDriveFileOutlined, null)));
function getEndIcon(hasZeroChildren, isTrash = false) {
    return !(hasZeroChildren || isTrash) ? undefined : (React.createElement(React.Fragment, null,
        React.createElement(ChevronRight, { color: hasZeroChildren ? 'disabled' : undefined }),
        isTrash ? React.createElement(Delete, null) : React.createElement(Folder, null)));
}
const StyledTreeItem = styled(TreeItem) `
  &.selected > [class*='MuiTreeItem-content']:first-child {
    background-color: #cfd8dc;
  }

  & [class*='MuiTreeItem-iconContainer'] {
    width: auto;
    margin: 5px 8px;
    color: rgb(0, 0, 0, 0.54);
  }

  .tree-thin & [class*='MuiTreeItem-group'] {
    margin-left: 12px;
  }

  & [class*='MuiTreeItem-label'] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: inherit;
    color: rgb(0, 0, 0, 0.87);
  }
`;
const FileExplorerItem = props => {
    const { file, manager, selected, hideTrashDir, includeFiles, renderTree, onSelectNode } = props;
    const { children, isLoading } = manager.find(file.id);
    const nodeId = `${file.id}`;
    const hasNoChildren = children.length === 0;
    const isTrash = file.name === 'Trash' && file.isLocked;
    const label = file.name + (isLoading && file.isFolder ? ' Loading...' : '');
    // use disabled color when there are 0 children fetched
    const endIcon = file.isFolder
        ? getEndIcon(hasNoChildren, isTrash)
        : selected
            ? selectedFileIcon
            : fileIcon;
    return (React.createElement(StyledTreeItem, { label: label, nodeId: nodeId, endIcon: endIcon, className: selected ? 'selected' : undefined, expandIcon: isTrash ? expandTrashIcon : undefined, collapseIcon: isTrash ? collapseTrashIcon : undefined, onClick: () => {
            if (file.isFolder && hasNoChildren) {
                manager.loadFile(file.id, {
                    withChildren: true,
                    withParent: false,
                    isFolderOnly: !includeFiles
                });
            }
            onSelectNode === null || onSelectNode === void 0 ? void 0 : onSelectNode(nodeId, file);
        } }, filterFileTree(children, hideTrashDir).map(renderTree)));
};
export default FileExplorerItem;
//# sourceMappingURL=FileExplorerItem.js.map